// extracted by mini-css-extract-plugin
module.exports = {"labels":"c1JAt","label":"ovqIB","label_type_text":"_68MRy","icon":"LXoLq"};